// extracted by mini-css-extract-plugin
export default {"card":"W4-z"};